import type { NamespaceCatalog } from '@/i18n/ns';

const copy: NamespaceCatalog<'producing' | 'interrupted' | 'expired'> = {
  bg: {
    producing: 'Показва се запазената част на отговора.',
    interrupted: 'Отговорът е прекъснат. Показва се запазената част.',
    expired: 'Отговорът е прекъснат. Запазеният напредък е изтекъл.',
  },
  hr: {
    producing: 'Prikazan je spremljeni dio odgovora.',
    interrupted: 'Odgovor je prekinut. Prikazan je spremljeni dio.',
    expired: 'Odgovor je prekinut. Spremljeni napredak je istekao.',
  },
  cs: {
    producing: 'Zobrazuje se uložená část odpovědi.',
    interrupted: 'Odpověď byla přerušena. Zobrazuje se uložená část.',
    expired: 'Odpověď byla přerušena. Uložený průběh již není dostupný.',
  },
  da: {
    producing: 'Den gemte del af svaret vises.',
    interrupted: 'Svaret blev afbrudt. Den gemte del vises.',
    expired: 'Svaret blev afbrudt. Den gemte fremgang er udløbet.',
  },
  nl: {
    producing: 'Het opgeslagen deel van het antwoord wordt getoond.',
    interrupted: 'Het antwoord is onderbroken. Het opgeslagen deel wordt getoond.',
    expired: 'Het antwoord is onderbroken. De opgeslagen voortgang is verlopen.',
  },
  en: {
    producing: 'Showing the saved part of this reply.',
    interrupted: 'This reply was interrupted. Showing the saved part.',
    expired: 'This reply was interrupted. Its saved progress has expired.',
  },
  et: {
    producing: 'Kuvatakse vastuse salvestatud osa.',
    interrupted: 'Vastus katkes. Kuvatakse salvestatud osa.',
    expired: 'Vastus katkes. Salvestatud edenemine on aegunud.',
  },
  fi: {
    producing: 'Vastauksen tallennettu osa näytetään.',
    interrupted: 'Vastaus keskeytyi. Tallennettu osa näytetään.',
    expired: 'Vastaus keskeytyi. Tallennettu eteneminen on vanhentunut.',
  },
  fr: {
    producing: 'La partie enregistrée de cette réponse est affichée.',
    interrupted: 'Cette réponse a été interrompue. La partie enregistrée est affichée.',
    expired: 'Cette réponse a été interrompue. Sa progression enregistrée a expiré.',
  },
  de: {
    producing: 'Der gespeicherte Teil dieser Antwort wird angezeigt.',
    interrupted: 'Diese Antwort wurde unterbrochen. Der gespeicherte Teil wird angezeigt.',
    expired: 'Diese Antwort wurde unterbrochen. Der gespeicherte Fortschritt ist abgelaufen.',
  },
  el: {
    producing: 'Εμφανίζεται το αποθηκευμένο μέρος της απάντησης.',
    interrupted: 'Η απάντηση διακόπηκε. Εμφανίζεται το αποθηκευμένο μέρος.',
    expired: 'Η απάντηση διακόπηκε. Η αποθηκευμένη πρόοδος έχει λήξει.',
  },
  hu: {
    producing: 'A válasz mentett része látható.',
    interrupted: 'A válasz megszakadt. A mentett rész látható.',
    expired: 'A válasz megszakadt. A mentett folyamat lejárt.',
  },
  ga: {
    producing: 'Taispeántar an chuid shábháilte den fhreagra.',
    interrupted: 'Cuireadh isteach ar an bhfreagra. Taispeántar an chuid shábháilte.',
    expired: 'Cuireadh isteach ar an bhfreagra. Tá an dul chun cinn sábháilte imithe in éag.',
  },
  it: {
    producing: 'Viene mostrata la parte salvata di questa risposta.',
    interrupted: 'Questa risposta è stata interrotta. Viene mostrata la parte salvata.',
    expired: 'Questa risposta è stata interrotta. I progressi salvati sono scaduti.',
  },
  lv: {
    producing: 'Redzama atbildes saglabātā daļa.',
    interrupted: 'Atbilde tika pārtraukta. Redzama saglabātā daļa.',
    expired: 'Atbilde tika pārtraukta. Saglabātā norise ir novecojusi.',
  },
  lt: {
    producing: 'Rodoma išsaugota atsakymo dalis.',
    interrupted: 'Atsakymas buvo nutrauktas. Rodoma išsaugota dalis.',
    expired: 'Atsakymas buvo nutrauktas. Išsaugota eiga nebegalioja.',
  },
  mt: {
    producing: 'Qed tintwera l-parti salvata ta’ din it-tweġiba.',
    interrupted: 'Din it-tweġiba ġiet interrotta. Qed tintwera l-parti salvata.',
    expired: 'Din it-tweġiba ġiet interrotta. Il-progress salvat skada.',
  },
  pl: {
    producing: 'Wyświetlana jest zapisana część odpowiedzi.',
    interrupted: 'Odpowiedź została przerwana. Wyświetlana jest zapisana część.',
    expired: 'Odpowiedź została przerwana. Zapisany postęp wygasł.',
  },
  pt: {
    producing: 'É apresentada a parte guardada desta resposta.',
    interrupted: 'Esta resposta foi interrompida. É apresentada a parte guardada.',
    expired: 'Esta resposta foi interrompida. O progresso guardado expirou.',
  },
  ro: {
    producing: 'Se afișează partea salvată a acestui răspuns.',
    interrupted: 'Acest răspuns a fost întrerupt. Se afișează partea salvată.',
    expired: 'Acest răspuns a fost întrerupt. Progresul salvat a expirat.',
  },
  sk: {
    producing: 'Zobrazuje sa uložená časť odpovede.',
    interrupted: 'Odpoveď bola prerušená. Zobrazuje sa uložená časť.',
    expired: 'Odpoveď bola prerušená. Uložený priebeh už nie je dostupný.',
  },
  sl: {
    producing: 'Prikazan je shranjeni del odgovora.',
    interrupted: 'Odgovor je bil prekinjen. Prikazan je shranjeni del.',
    expired: 'Odgovor je bil prekinjen. Shranjeni napredek je potekel.',
  },
  es: {
    producing: 'Se muestra la parte guardada de esta respuesta.',
    interrupted: 'Esta respuesta se interrumpió. Se muestra la parte guardada.',
    expired: 'Esta respuesta se interrumpió. El progreso guardado ha caducado.',
  },
  sv: {
    producing: 'Den sparade delen av svaret visas.',
    interrupted: 'Svaret avbröts. Den sparade delen visas.',
    expired: 'Svaret avbröts. De sparade framstegen har gått ut.',
  },
};
export default copy;
